"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof2 = require("babel-runtime/helpers/typeof");

var _typeof3 = _interopRequireDefault(_typeof2);

var _keys = require("babel-runtime/core-js/object/keys");

var _keys2 = _interopRequireDefault(_keys);

var _balloon = require("@alicd/next/lib/balloon");

var _balloon2 = _interopRequireDefault(_balloon);

var _icon = require("@alicd/next/lib/icon");

var _icon2 = _interopRequireDefault(_icon);

exports.renderTitleWithTooltip = renderTitleWithTooltip;
exports.unwrapParamsToElement = unwrapParamsToElement;
exports.renderCellInnermost = renderCellInnermost;
exports.renderHeaderInnermost = renderHeaderInnermost;
exports.renderCellWrapTextWrapWidth = renderCellWrapTextWrapWidth;
exports.renderCellWrapStyle = renderCellWrapStyle;
exports.renderCellClickTrigger = renderCellClickTrigger;
exports.renderCellWrapTooltip = renderCellWrapTooltip;
exports.renderCellWrapCopy = renderCellWrapCopy;
exports.getColumnMinWidth = getColumnMinWidth;
exports.renderCellWrapAutoLayout = renderCellWrapAutoLayout;
exports.renderTitleWrapAutoLayout = renderTitleWrapAutoLayout;
exports.renderCellIdentity = renderCellIdentity;
exports.renderCellWrapGreedy = renderCellWrapGreedy;
exports.renderTitleWithAutoMinWidth = renderTitleWithAutoMinWidth;
exports.sequence = sequence;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _copyToClipboard = require("copy-to-clipboard");

var _copyToClipboard2 = _interopRequireDefault(_copyToClipboard);

var _CellWithCopyBalloon = require("./CellWithCopyBalloon");

var _CellWithCopyBalloon2 = _interopRequireDefault(_CellWithCopyBalloon);

var _ContentTooltip = require("./ContentTooltip");

var _ContentTooltip2 = _interopRequireDefault(_ContentTooltip);

var _columnUtils = require("./column-utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function renderTitleWithTooltip(title, titleTooltip) {
    return _react2.default.createElement(
        "span",
        { className: "cn-table-header-with-tooltip" },
        _react2.default.createElement(
            _balloon2.default,
            {
                className: "cn-table-tooltip",
                align: "t",
                closable: false,
                trigger: _react2.default.createElement(_icon2.default, { type: "help", size: "small" })
            },
            titleTooltip
        ),
        _react2.default.createElement(
            "span",
            null,
            title
        )
    );
}

function wrapParams(ret, state) {
    return { ret: ret, state: state };
}

function unwrapParamsToElement(params) {
    return params.ret;
}

function _renderCellInnermost(value, index, record, self) {
    if (this.cnTableProps.cell) {
        return this.cnTableProps.cell(value, index, record, self);
    } else {
        return value;
    }
}

function renderCellInnermost(value, index, record, self, colId) {
    return wrapParams(_renderCellInnermost.call(this, value, index, record, self), {
        props: this.cnTableProps,
        value: value, record: record, index: index, self: self, colId: colId
    });
}

function renderHeaderInnermost(title, self, colId) {
    return wrapParams(title, { props: this.props, self: self, colId: colId });
}

function renderCellWrapTextWrapWidth(params) {
    var ret = params.ret,
        state = params.state,
        props = params.state.props;

    if (!props.wrap) {
        return wrapParams(_react2.default.createElement(
            "span",
            { className: "cn-table-cell-span-nowrap" },
            ret
        ), state);
    }
    return params;
}

function renderCellWrapStyle(params) {
    var ret = params.ret,
        state = params.state,
        props = params.state.props;

    var className = {
        "cn-table-cell-nowrap": !props.wrap,
        "cn-table-cell-wrapper": !!(props.wrap || props.onClick),
        /* "next-table-cell-wrapper": !!(props.wrap || props.clickToSelectRow),*/
        /* "cn-table-cell-wrapper-select-trigger": !!(props.clickToSelectRow)*/
        "cn-table-cell-click-wrap": !!props.onClick
    };
    return !(0, _keys2.default)(className).length ? params : wrapParams(_react2.default.createElement(
        "div",
        { className: (0, _classnames2.default)(className) },
        ret
    ), state);
}

function renderCellClickTrigger(params) {
    var ret = params.ret,
        state = params.state,
        _params$state = params.state,
        record = _params$state.record,
        value = _params$state.value,
        index = _params$state.index,
        props = _params$state.props;

    if (!props.onClick) {
        return params;
    }
    return wrapParams(_react2.default.createElement(
        "div",
        { className: "cn-table-cell-click-trigger", onClick: props.onClick.bind(null, value, index, record) },
        ret
    ), state);
}

function ensureVDOMNodeIsElement(node) {
    if ((typeof node === "undefined" ? "undefined" : (0, _typeof3.default)(node)) !== "object" && typeof node !== "function") {
        return _react2.default.createElement(
            "span",
            null,
            node
        );
    }
    return node;
}

function renderCellWrapTooltip(params) {
    var ret = params.ret,
        state = params.state,
        _params$state2 = params.state,
        props = _params$state2.props,
        value = _params$state2.value;


    if (props.contentTooltip && value) {
        // if (props.cell) {
        // console.warn("CNTable: you have assigned a \"cell\" prop for a <CNTable.Column> component with prop \"contentTooltip\", which supports plain \"dataIndex\" only by now.");
        // }
        return wrapParams(_react2.default.createElement(_ContentTooltip2.default, {
            trigger: ensureVDOMNodeIsElement(ret),
            value: value.toString(),
            wrappedOnly: props.contentTooltip == "overflow-only"
        }), state);
    } else {
        return params;
    }
}

function doCopy(props, value, index, record) {
    var valueForClipboard = props.onBeforeCopy(value, index, record).toString();
    (0, _copyToClipboard2.default)(valueForClipboard);
    props.onCopy && props.onCopy(valueForClipboard, index, record);
}

function renderCellWrapCopy(params) {
    var ret = params.ret,
        state = params.state,
        _params$state3 = params.state,
        props = _params$state3.props,
        value = _params$state3.value,
        record = _params$state3.record,
        index = _params$state3.index,
        self = _params$state3.self;

    if (!props.copy || !value) {
        return params;
    }

    /* TODO: eliminate the "bind()" */
    return wrapParams(_react2.default.createElement(_CellWithCopyBalloon2.default, {
        trigger: ensureVDOMNodeIsElement(ret),
        onClick: doCopy.bind(null, props, value, index, record),
        text: self.props.locale.copy
    }), state);
}

function getColumnMinWidthNoWidth(table, props, colIdx, xIndex, yIndex) {
    if (!props.autoMinWidth) {
        return props.minWidth;
    } else {
        var nextTableRef = table.refs.nextTable;
        if (nextTableRef) {
            var nextTable = nextTableRef.getInstance();
            var node = nextTable.refs[nextTable.getHeaderRef(yIndex, xIndex, false)];
            if (node) {
                var beam = node.getElementsByClassName("cn-table-title-greedy-beam")[0];
                if (beam) {
                    var w = beam.clientWidth;
                    // TODO: the width of sort should be adaptive
                    // TODO: since we are unable to access theme variables ...
                    //  try not to hardcode this!!
                    return w + 36 + 13 + 2;
                }
            }
        }
        return props.minWidth;
    }
}

function getColumnMinWidth(table, props, colIdx, xIndex, yIndex) {
    var ret = getColumnMinWidthNoWidth(table, props, colIdx, xIndex, yIndex);
    return Math.max(ret, props.width || 0);
}

function renderCellWrapAutoLayout(params) {
    var ret = params.ret,
        state = params.state,
        _params$state4 = params.state,
        props = _params$state4.props,
        colId = _params$state4.colId,
        self = _params$state4.self;


    var style = {};
    // if (props.maxWidth) { style.maxWidth = props.maxWidth }
    if (props.minWidth || props.autoMinWidth) {
        style.minWidth = getColumnMinWidth(self, props, colId.idx, colId.x, colId.y);
    }
    // is this "greedyWidthNativelySupported" necessary?
    if (props.greedy && _columnUtils.greedyWidthNativelySupported) {
        style.width = _columnUtils.greedyWidthNativelySupported;
    }

    return wrapParams(_react2.default.createElement(
        "span",
        { className: "cn-table-cell-auto-layout", style: style },
        ret
    ), state);
}

function renderTitleWrapAutoLayout(params) {
    var ret = params.ret,
        state = params.state;


    return wrapParams(_react2.default.createElement(
        "span",
        { className: "cn-table-cell-auto-layout" },
        ret
    ), state);
}

function renderCellIdentity(params) {
    return params;
}

function renderCellWrapGreedy(params) {
    var ret = params.ret,
        state = params.state,
        props = params.state.props;


    if (!props.greedy || _columnUtils.greedyWidthNativelySupported) {
        return params;
    }

    return wrapParams(_react2.default.createElement(
        "span",
        { className: "cn-table-cell-greedy-wrap" },
        ret,
        _react2.default.createElement(
            "div",
            { className: "cn-table-cell-greedy-beam" },
            ret
        )
    ), state);
}

function renderTitleWithAutoMinWidth(i) {
    return function renderTitleWithAutoMinWidthInternal(params) {
        var ret = params.ret,
            state = params.state,
            _params$state5 = params.state,
            props = _params$state5.props,
            self = _params$state5.self;

        function f(ref) {
            if (!ref) {
                self.autoMinWidthColumns[i] = null;
            } else if (self.autoMinWidthColumns[i] && self.autoMinWidthColumns[i].ref == ref) {} else {
                self.autoMinWidthColumns[i] = { ref: ref };
            }
        }
        return wrapParams(_react2.default.createElement(
            "span",
            { className: "cn-table-title-greedy-wrap" },
            ret,
            _react2.default.createElement(
                "div",
                {
                    className: "cn-table-title-greedy-beam",
                    ref: f
                },
                ret
            )
        ), state);
    };
}

function sequence(firstFunc) {
    for (var _len = arguments.length, funcs = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        funcs[_key - 1] = arguments[_key];
    }

    return function () {
        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            args[_key2] = arguments[_key2];
        }

        return funcs.reduce(function (param, func) {
            return func(param);
        }, firstFunc.apply(this, args));
    };
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_crui-table@0.0.78@@alicd/crui-table/lib/CNTableCellUtils.js
// module id = 695
// module chunks = 0